import { createContext } from 'react';

export type FortuneContextType = {
  getTranslation?: (key: string) => string;
  lang?: 'en' | 'id';
};

export const FortuneContext = createContext<FortuneContextType>({});
